import { useEffect, useState } from "react";
import type { ActionContext } from "react-grab";
import { DevFeedbackModal } from "./dev-feedback-modal";

export interface ElementContext {
  filePath?: string;
  componentName?: string;
  lineNumber?: number;
  tagName?: string;
  htmlSnippet?: string;
  pageUrl: string;
}

function captureElementContext(context: ActionContext): ElementContext {
  const element = context.element;
  const outerHtml = element?.outerHTML ?? "";
  const maxLength = 500;
  const truncatedHtml =
    outerHtml.length > maxLength
      ? outerHtml.slice(0, maxLength) + "..."
      : outerHtml;

  return {
    filePath: context.filePath,
    componentName: context.componentName,
    lineNumber: context.lineNumber,
    tagName: context.tagName,
    htmlSnippet: truncatedHtml,
    pageUrl: window.location.href,
  };
}

export function DevFeedbackPlugin() {
  const [isOpen, setIsOpen] = useState(false);
  const [elementContext, setElementContext] = useState<ElementContext | null>(
    null,
  );

  useEffect(() => {
    let isDisposed = false;
    let cleanup: (() => void) | undefined;

    void import("react-grab")
      .then(({ registerPlugin, unregisterPlugin }) => {
        if (isDisposed) return;
        registerPlugin({
          name: "dev-feedback",
          actions: [
            {
              id: "request-change",
              label: "Request Change",
              shortcut: "R",
              onAction: (context) => {
                setElementContext(captureElementContext(context));
                setIsOpen(true);
                context.hideContextMenu();
              },
            },
          ],
        });
        cleanup = () => unregisterPlugin("dev-feedback");
      })
      .catch(() => undefined);

    return () => {
      isDisposed = true;
      cleanup?.();
    };
  }, []);

  return (
    <DevFeedbackModal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
        setElementContext(null);
      }}
      elementContext={elementContext}
    />
  );
}
